import React, { useState, useEffect } from 'react';
// import BackToServicesButton from '../components/BackToServicesButton';
import API_BASE_URL from '../api';
import { authFetch } from '../authFetch';
import { useAuth } from '../authContext';
import useSelectedRadio from '../hooks/useSelectedRadio';
import { useTranslation } from 'react-i18next';
import { fmtNumber, useLocale } from '../i18n/format';
import ExportButton from '../components/ExportButton';
import { buildRetentionDoc } from "../pdf/builders/retention/buildDoc";

export default function RetentionServicePage() {
  const { radioId, shortcode, name: stationName } = useSelectedRadio();
  const [date1, setDate1] = useState('');
  const [info, setInfo] = useState('');
  const [returned, setReturned] = useState(null);
  const [newTotal, setNewTotal] = useState(null);
  const [percent, setPercent] = useState(null);
  const [period, setPeriod] = useState('');
  const { isAuth } = useAuth();
  const { t } = useTranslation('common');
  const locale = useLocale();

  useEffect(() => {
    if (!date1) {
      const today = new Date();
      setDate1(today.toISOString().slice(0, 10));
    }
  }, [date1]);

  const fetchData = async (d = date1) => {
    if (!isAuth || !radioId || !d) return;
    setInfo(t('common.loading'));
    setReturned(null); setNewTotal(null); setPercent(null); setPeriod('');
    try {
      const API = (API_BASE_URL || '').replace(/\/+$/, '');
      const url = `${API}/radios/${encodeURIComponent(radioId)}/metrics/retention-rate?date1=${d}`;
      const resp = await authFetch(url);
      const data = await resp.json();
      if (data.error) {
        setInfo(data.error);
        return;
      }
      setReturned(data.returned ?? 0);
      setNewTotal(data.new_total ?? 0);
      setPercent(data.percent ?? 0);
      setPeriod(t('retention.period_note', { start: data.start, end: data.end }));
      setInfo('');
    } catch {
      setInfo(t('common.network_error'));
    }
  };

  // Данные получаем только по кнопке
  if (!radioId) {
    return (
      <div style={widgetStyle}>
        {/* BackToServicesButton removed */}
        <h2 style={{ marginBottom: 8 }}>{t('retention.title')}</h2>
        <div style={{ color: '#e54848', fontWeight: 600, fontSize: 18 }}>
          {t('common.no_channel')}
        </div>
      </div>
    );
  }

  return (
    <div style={widgetStyle}>
      {/* BackToServicesButton removed */}

      {/* Описание сервиса */}
      <div
        style={{
          width: "100%",
          padding: "12px 14px",
          borderRadius: 8,
          background: "#f8f8f8",
          color: "#1a1a1a",
          fontSize: 16.5,
          margin: "8px 0 20px 0",
          boxSizing: "border-box",
          whiteSpace: "pre-line",
          lineHeight: 1.65
        }}
      >
        {t('retention.description')}
      </div>

      <h2 style={{ marginBottom: 8 }}>{t('retention.title')}</h2>
      <div style={{ marginBottom: 12 }}>
        <label>📅 {t('retention.end_date')} </label>
        <input
          type="date"
          value={date1}
          onChange={e => setDate1(e.target.value)}
          style={inputStyle}
        />
        <span style={{ fontSize: "0.92em", color: "#999", marginLeft: 8 }}>
          {t('retention.calc_hint')}
        </span>
        <button onClick={() => fetchData()} style={{ ...showBtn, width: 160 }}>{t('common.show')}</button>
        <div style={{ display: 'inline-block', marginLeft: 8 }}>
          <ExportButton
            data={{ returned, newTotal, percent, period, date1 }}
            onBeforeBuild={async () => {
              // логотип из public
              const url = `${process.env.PUBLIC_URL || ''}/Radiomonitor.NetLogo.png`;
              try {
                const resp = await fetch(url, { cache: 'no-store' });
                const blob = await resp.blob();
                const reader = new FileReader();
                const dataUrl = await new Promise((res, rej) => {
                  reader.onloadend = () => res(reader.result);
                  reader.onerror = rej;
                  reader.readAsDataURL(blob);
                });
                return { logoDataUrl: dataUrl };
              } catch {
                return { logoDataUrl: null };
              }
            }}
            buildDoc={(payload) =>
              buildRetentionDoc({
                t, shortcode, stationName,
                serviceName: t('retention.title'),
                date1,
                returned, newTotal, percent,
                period, fmtNumber, locale,
                logoDataUrl: payload?.logoDataUrl || null
              })
            }
            filename={`retention_${shortcode}_${date1}.pdf`}
            label={t('export_pdf')}
            style={{
              ...showBtn,
              width: 160,
              background: (info !== '' || returned === null || newTotal === null || percent === null)
                ? '#9bbdfd'
                : '#3867fa'
            }}
            disabled={info !== '' || returned === null || newTotal === null || percent === null}
          />
        </div>
      </div>
      {info && <div style={{ color: 'red', fontWeight: 500, margin: "14px 0" }}>{info}</div>}
      {!info && newTotal !== null &&
        <>
          <div style={{
            fontSize: "1.45em",
            fontWeight: "bold",
            color: "#1785db",
            marginBottom: 7
          }}>
            {t('retention.returned_stat', {
              returned: fmtNumber(returned, locale),
              total: fmtNumber(newTotal, locale),
              percent: fmtNumber(percent, locale)
            })}
          </div>
          <div style={{ color: "#888", fontSize: "0.96em" }}>
            {period}
          </div>
        </>
      }
    </div>
  );
}

const widgetStyle = {
  maxWidth: 1080,
  margin: '40px auto',
  background: '#fff',
  borderRadius: 14,
  padding: 24,
  boxShadow: '0 2px 12px 0 #0001'
};

const inputStyle = {
  marginLeft: 7,
  marginRight: 7,
  padding: 7,
  borderRadius: 4,
  border: '1px solid #ccc',
  fontSize: 16,
  minWidth: 130
};

const showBtn = {
  background: '#3867fa',
  color: '#fff',
  border: 'none',
  padding: '8px 16px',
  borderRadius: 5,
  fontWeight: 600,
  cursor: 'pointer',
  marginLeft: 10
};
